import { IoCheckmarkCircleOutline } from "react-icons/io5";
import img1 from "../../../assets/img/Industries/Energy/cloud.jpg";
import { IoCloudDoneOutline } from "react-icons/io5";
import { BsDatabase } from "react-icons/bs";
import { FaShieldAlt } from "react-icons/fa"; // Security icon

export default function MainSection6() {
  return (
    <div className="container mx-auto px-4 py-12 md:py-12 md:px-10">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center">
        <div className="space-y-8">
          <div className="space-y-4">
            <h1 className="text-4xl md:text-5xl font-bold leading-tight text-gray-900">
              Cloud-Enabled Digital Transformation
            </h1>
            <p className="text-lg text-gray-600">
              Transform your energy and utilities operations with scalable, secure, and data-driven cloud solutions.
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-8">
            {/* Feature 1 */}
            <div className="space-y-3">
              <div className="flex items-center space-x-2">
                <IoCloudDoneOutline className="w-6 h-6 text-indigo-600" />
                <h3 className="font-semibold text-gray-900">Scalable Infrastructure</h3>
              </div>
              <p className="text-gray-600 text-sm">
                Move legacy systems to the cloud, ensuring scalability and agility in meeting growing energy demands.
              </p>
            </div>

            {/* Feature 2 */}
            <div className="space-y-3">
              <div className="flex items-center space-x-2">
                <BsDatabase className="w-6 h-6 text-indigo-600" />
                <h3 className="font-semibold text-gray-900">Centralized Data Management</h3>
              </div>
              <p className="text-gray-600 text-sm">
                Consolidate data across operations, enabling seamless integration of systems and fostering collaboration.
              </p>
            </div>

            {/* Feature 3 */}
            <div className="space-y-3">
              <div className="flex items-center space-x-2">
                <FaShieldAlt className="w-6 h-6 text-indigo-600" />
                <h3 className="font-semibold text-gray-900">Enhanced Security</h3>
              </div>
              <p className="text-gray-600 text-sm">
                Utilize cloud-native security protocols to protect sensitive operational and customer data.
              </p>
            </div>
          </div>
        </div>

        <div className="relative h-[500px] rounded-3xl overflow-hidden">
          <img
            src={img1}
            alt="Workspace with laptop and plant"
            className="object-cover w-full h-full rounded-3xl"
          />
        </div>
      </div>
    </div>
  );
}